import api from './api';

export const dashboardService = {
  fetch: async () => {
    const response = await api.get('/dashboard');
    return response.data;
  },
};
